"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var colors = {
  primaryLightest: "#aad2ff",
  primaryLight: "#64a2ff",
  primary: "#196cff",
  primaryDark: "#0042cb",
  primaryDarkest: "#0f3bcf",
  secondaryLightest: "#dddef9",
  secondaryLight: "#777be7",
  secondary: "#454ade",
  secondaryDark: "#393db6",
  tertiaryLightest: "#d2f2f2",
  tertiaryLight: "#4ecdcd",
  tertiary: "#0cbaba",
  tertiaryDark: "#0a9999",
  success: "#0cbaba",
  error: "#ff7156",
  neutralLightest: "#efefef",
  neutralLighter: "#d9d9d9",
  neutralLight: "#b9b9b9",
  neutral: "#939393",
  neutralDark: "#505050",
  neutralDarker: "#323232",
  neutralDarkest: "#191919",
  landingYellow: "#ffb54a",
  landingYellowDark: "#d39b4b",
  landingYellowLight: "#ffecd1",
  landingRed: "#ff7156",
  landingRedDark: "#d36854",
  landingRedLight: "#ffdbd4",
  landingBlue: "#4b5769",
  landingBlueDark: "#404853",
  landingBlueLight: "#d1d4d9",
  landingBackground: "#fcfaf6",
  fantasy: "#fcfaf6",
  white: "#ffffff",
  black: "#000000",
  purple: "#8018ff",
  transparent: "transparent"
};

exports.default = colors;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-theme/dist/colors.js
// module id = 455
// module chunks = 168707334958949